import Barcode from "react-barcode";
import logo from "../../../../../logo.svg";
import { signInUser } from "../../../../Utility/Auth";
import { resolvePhotoUrl } from "../../../../Utility/resolvePhotoUrl";
import { useEffect, useState } from "react";
import { useWarehouseQuery } from "../../../../../services/warehouseApi";

const PoHeader = ({ purchase, format, title }) => {
  const supplier = purchase?.supplier;
  const auth = signInUser();

  const { storeSettings } = auth;
  // console.log("Settings::>>", storeSettings)
  // console.log(supplier);
  // console.log(purchase);
  return (
    <>
      <div className="row  pb-3 mb-1 border-bottom">
        <div className="col-7">
          <img
            src={resolvePhotoUrl(
              storeSettings?.storePhoto || storeSettings?.photo,
              logo
            )}
            onError={(e) => {
              e.target.src = logo;
            }}
            height="40"
            alt="not Image"
          />
        </div>

        <div className="col-5">
          <p className="p-0 m-0 text-end">
            <b>Hotline: </b> {storeSettings?.phone || "01700000000"}
          </p>
          <p className="p-0 m-0 text-end">
            <small>{purchase?.warehouse?.name}</small>{" "}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-6 print-header-text">
          <p>
            <b>To</b> <br />
            {supplier?.company} <br />
            {supplier?.email} <br />
            {supplier?.phone} <br />
            {supplier?.address} <br />
          </p>

          <p>
            <b>Form</b> <br />
            {storeSettings?.storeName || "No-Name"} <br />
            {storeSettings?.email || "No-Email"}
            <br />
            {storeSettings?.phone || "0170000"}
            <br />
            {storeSettings?.address?.street || "No-Street"} ,
            {storeSettings?.address?.city || "No-City"},{" "}
            {storeSettings?.address?.state || "No-State"},{" "}
            {storeSettings?.address?.post || "No-PostalCode"} <br />
          </p>
        </div>
        <div className="col-6 text-end">
          {!purchase?.print ? <h4>[ORIGINAL]</h4> : <h4>[DUPLICATE]</h4>}

          <h4>{title}</h4>
          <span className="ps-6 d-block">
            <p>
              <b>PO No:</b> {purchase?.poNo}
              <br />
              <b>PO Date:</b>{" "}
              {purchase?.createdAt &&
                format(new Date(purchase?.createdAt), "MM-dd-yyyy")}{" "}
              <br />
              <b>PO Time:</b>{" "}
              {purchase?.createdAt &&
                format(new Date(purchase?.createdAt), "h:m:s aaa")}
              <br />
              <b>Status:</b> {purchase?.status}
            </p>
            <p className="text-end bar-code">
              <Barcode
                value={purchase?.poNo}
                height="40"
                width="2"
                fontSize="10"
              />
            </p>
          </span>
        </div>
      </div>
    </>
  );
};

export default PoHeader;
